import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { Row, Col } from "antd";
import Metric from "./Metric";

import "./MetricBar.css";

function MetricBar({ orgDashboardStore, userCode, heartRate, hrv, motion }) {
  const colorForHrv = useMemo(() => {
    let color = "inactive";
    if (!hrv || !orgDashboardStore.isActive[userCode]) {
      return color;
    }
    const classification = hrv.classification;

    if (classification === "no-data" || classification === "unknown") {
      color = "inactive";
    } else if (classification === "low" || classification === "high") {
      color = "yellow";
    } else if (classification === "normal") {
      color = "green";
    }
    return color;
  }, [userCode, hrv]);

  const colorForHeartRate = useMemo(() => {
    let color = "inactive";
    if (!heartRate || !orgDashboardStore.isActive[userCode]) {
      return color;
    }

    const classification = heartRate.classification;

    if (classification === "no-data" || classification === "unknown") {
      color = "inactive";
    } else if (classification === "high" || classification === "low") {
      color = "yellow";
    } else if (
      classification === "very-low" ||
      classification === "very-high"
    ) {
      color = "red";
    } else if (classification === "normal") {
      color = "green";
    }
    return color;
  }, [userCode, heartRate]);

  const colorForMotion = useMemo(() => {
    let color = "inactive";
    if (!motion || !orgDashboardStore.isActive[userCode]) {
      return color;
    }
    const classification = motion.classification;

    if (classification === "no-data" || classification === "unknown") {
      color = "inactive";
    } else if (
      classification === "none" ||
      classification === "limited" ||
      classification === "some"
    ) {
      color = "green";
    } else if (classification === "high") {
      color = "yellow";
    }
    return color;
  }, [userCode, motion]);

  return (
    <>
      <div className="MetricBar">
        <Row className="UserCircle__metric_container">
          <Col span={8}>
            <Metric
              label="Heart"
              unit="bpm"
              value={heartRate?.value}
              color={colorForHeartRate}
            ></Metric>
          </Col>
          <Col span={8}>
            <Metric
              label="HRV"
              unit="sdnn"
              value={hrv?.value.toFixed(0)}
              color={colorForHrv}
            ></Metric>
          </Col>
          <Col span={8}>
            <Metric
              label="Motion"
              unit=""
              value={motion?.classification?.toUpperCase()}
              color={colorForMotion}
              fontSize="1.3rem"
            ></Metric>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default observer(MetricBar);
